module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mixed_mobile2-0ff6011e1b69e9df0c7d13c128f31745.jpg";